export type IHandleViewDataModalClick = ($button: IjQueryElmOrHtmlElm) => void;

export function handleViewDataModalClick($button: IjQueryElmOrHtmlElm): void {
  const $modal = $('#view-data-modal');
  const { isShown } = $modal.data('bs.modal') || { isShown: false };
  if (isShown) {
    window.DexeroCoreApp._resetViewDataModal($modal);
  } else {
    $modal.modal('show');
  }
  window.DexeroCoreApp._getDataForViewDataModal($modal, $button);
  window.DexeroCoreApp.lastModalTrigger = $button;
}
